export default [
    {
        logoId: 1,
        name: "Mjolnir",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 37,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 11 de dano físico que após 3 segundos explode causando 57 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 1,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 45,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 14 de dano físico que após 3 segundos explode causando 69 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 4,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 60,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 19 de dano físico que após 3 segundos explode causando 92 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 8,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 78,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 24 de dano físico que após 3 segundos explode causando 120 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 12,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 98,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 30 de dano físico que após 3 segundos explode causando 150 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 16,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 121,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 37 de dano físico que após 3 segundos explode causando 186 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 20,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 146,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 45 de dano físico que após 3 segundos explode causando 225 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 24,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 177,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 54 de dano físico que após 3 segundos explode causando 272 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 28,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 216,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 66 de dano físico que após 3 segundos explode causando 332 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 32,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 261,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 80 de dano físico que após 3 segundos explode causando 401 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 36,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 315,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 97 de dano físico que após 3 segundos explode causando 484 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 40,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 371,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 114 de dano físico que após 3 segundos explode causando 570 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 44,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 437,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 135 de dano físico que após 3 segundos explode causando 673 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 48,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 508,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 156 de dano físico que após 3 segundos explode causando 782 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 52,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 589,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 181 de dano físico que após 3 segundos explode causando 906 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 56,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 676,
                cast: 0,
                info:
                    "Atira um projétil com facion instável que causa 208 de dano físico que após 3 segundos explode causando 1040 de dano físico onde o dano não pode ser evitado.",
                necessaryLevel: 60,
            },
        ],
    },
    {
        logoId: 2,
        name: "Espinho Venenoso",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 69,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 3 segundos, infligindo 33 de dano físico por segundo e diminuindo a resistência a status anormais em 6.",
                necessaryLevel: 4,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 92,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 3 segundos, infligindo 44 de dano físico por segundo e diminuindo a resistência a status anormais em 7.",
                necessaryLevel: 8,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 121,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 3 segundos, infligindo 58 de dano físico por segundo e diminuindo a resistência a status anormais em 8.",
                necessaryLevel: 12,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 151,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 4 segundos, infligindo 72 de dano físico por segundo e diminuindo a resistência a status anormais em 9.",
                necessaryLevel: 16,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 187,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 4 segundos, infligindo 89 de dano físico por segundo e diminuindo a resistência a status anormais em 10.",
                necessaryLevel: 20,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 227,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 4 segundos, infligindo 108 de dano físico por segundo e diminuindo a resistência a status anormais em 11.",
                necessaryLevel: 24,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 275,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 4 segundos, infligindo 131 de dano físico por segundo e diminuindo a resistência a status anormais em 12.",
                necessaryLevel: 28,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 336,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 5 segundos, infligindo 160 de dano físico por segundo e diminuindo a resistência a status anormais em 13.",
                necessaryLevel: 32,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 405,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 5 segundos, infligindo 193 de dano físico por segundo e diminuindo a resistência a status anormais em 14.",
                necessaryLevel: 36,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 489,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 5 segundos, infligindo 233 de dano físico por segundo e diminuindo a resistência a status anormais em 15.",
                necessaryLevel: 40,
            },
            {
                level: 11,
                cooldown: 20,
                mp: 578,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 5 segundos, infligindo 275 de dano físico por segundo e diminuindo a resistência a status anormais em 16.",
                necessaryLevel: 44,
            },
            {
                level: 12,
                cooldown: 20,
                mp: 680,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 5 segundos, infligindo 324 de dano físico por segundo e diminuindo a resistência a status anormais em 17.",
                necessaryLevel: 48,
            },
            {
                level: 13,
                cooldown: 20,
                mp: 790,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 6 segundos, infligindo 376 de dano físico por segundo e diminuindo a resistência a status anormais em 18.",
                necessaryLevel: 52,
            },
            {
                level: 14,
                cooldown: 20,
                mp: 916,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 6 segundos, infligindo 436 de dano físico por segundo e diminuindo a resistência a status anormais em 19.",
                necessaryLevel: 56,
            },
            {
                level: 15,
                cooldown: 20,
                mp: 1046,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 6 segundos, infligindo 498 de dano físico por segundo e diminuindo a resistência a status anormais em 20.",
                necessaryLevel: 60,
            },
            {
                level: 16,
                cooldown: 20,
                mp: 1182,
                cast: 0,
                info:
                    "Cria um espinho venenoso sob os pés do inimigo para imobilizá-lo por 6 segundos, infligindo 563 de dano físico por segundo e diminuindo a resistência a status anormais em 21.",
                necessaryLevel: 64,
            },
        ],
    },
    {
        logoId: 3,
        name: "Ação Imediata",
        levelsInfo: [
            {
                level: 1,
                cooldown: 150,
                mp: 40,
                cast: 0,
                info:
                    "Aumenta a velocidade de movimento em 10 e a evasão em 14 por 20 segundos.",
                necessaryLevel: 6,
            },
            {
                level: 2,
                cooldown: 150,
                mp: 52,
                cast: 0,
                info:
                    "Aumenta a velocidade de movimento em 10 e a evasão em 16 por 21 segundos.",
                necessaryLevel: 10,
            },
            {
                level: 3,
                cooldown: 150,
                mp: 64,
                cast: 0,
                info:
                    "Aumenta a velocidade de movimento em 10 e a evasão em 18 por 22 segundos.",
                necessaryLevel: 14,
            },
            {
                level: 4,
                cooldown: 150,
                mp: 79,
                cast: 0,
                info:
                    "Aumenta a velocidade de movimento em 10 e a evasão em 20 por 23 segundos.",
                necessaryLevel: 18,
            },
            {
                level: 5,
                cooldown: 150,
                mp: 96,
                cast: 0,
                info:
                    "Aumenta a velocidade de movimento em 10 e a evasão em 22 por 24 segundos.",
                necessaryLevel: 22,
            },
            {
                level: 6,
                cooldown: 150,
                mp: 115,
                cast: 0,
                info:
                    "Aumenta a velocidade de movimento em 10 e a evasão em 24 por 25 segundos.",
                necessaryLevel: 26,
            },
            {
                level: 7,
                cooldown: 150,
                mp: 138,
                cast: 0,
                info:
                    "Aumenta a velocidade de movimento em 10 e a evasão em 26 por 26 segundos.",
                necessaryLevel: 30,
            },
            {
                level: 8,
                cooldown: 150,
                mp: 165,
                cast: 0,
                info:
                    "Aumenta a velocidade de movimento em 10 e a evasão em 28 por 27 segundos.",
                necessaryLevel: 34,
            },
            {
                level: 9,
                cooldown: 150,
                mp: 198,
                cast: 0,
                info:
                    "Aumenta a velocidade de movimento em 10 e a evasão em 30 por 28 segundos.",
                necessaryLevel: 38,
            },
            {
                level: 10,
                cooldown: 150,
                mp: 233,
                cast: 0,
                info:
                    "Aumenta a velocidade de movimento em 10 e a evasão em 33 por 30 segundos ocultando-se rapidamente por 3 segundos.",
                necessaryLevel: 42,
            },
        ],
    },
    {
        logoId: 4,
        name: "Maximizar",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 70,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 10 e a habilidade de ataque em 39.",
                necessaryLevel: 8,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 87,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 13 e a habilidade de ataque em 49.",
                necessaryLevel: 12,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 107,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 16 e a habilidade de ataque em 61.",
                necessaryLevel: 16,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 131,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 19 e a habilidade de ataque em 75.",
                necessaryLevel: 20,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 157,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 22 e a habilidade de ataque em 91.",
                necessaryLevel: 24,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 189,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 27 e a habilidade de ataque em 110.",
                necessaryLevel: 28,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 226,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 32 e a habilidade de ataque em 134.",
                necessaryLevel: 32,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 271,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 38 e a habilidade de ataque em 162.",
                necessaryLevel: 36,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 324,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 44 e a habilidade de ataque em 196.",
                necessaryLevel: 40,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 378,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 51 e a habilidade de ataque em 231.",
                necessaryLevel: 44,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 442,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 59 e a habilidade de ataque em 273.",
                necessaryLevel: 48,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 508,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 68 e a habilidade de ataque em 317.",
                necessaryLevel: 52,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 582,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 78 e a habilidade de ataque em 367.",
                necessaryLevel: 56,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 662,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 88 e a habilidade de ataque em 422.",
                necessaryLevel: 60,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 737,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 99 e a habilidade de ataque em 474.",
                necessaryLevel: 64,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 819,
                cast: 2,
                info:
                    "Preenche as pistolas com poder aumentando o dano físico em 116 e a habilidade de ataque em 534.",
                necessaryLevel: 68,
            },
        ],
    },
    {
        logoId: 5,
        name: "Ocultar",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 26,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 20 segundos reinicializando a taxa de perigo e reduzindo a movimentação em 12 pontos.",
                necessaryLevel: 10,
            },
            {
                level: 2,
                cooldown: 60,
                mp: 32,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 21 segundos reinicializando a taxa de perigo e reduzindo a movimentação em 6 pontos.",
                necessaryLevel: 14,
            },
            {
                level: 3,
                cooldown: 60,
                mp: 39,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 22 segundos reinicializando a taxa de perigo e reduzindo a movimentação em 3 pontos.",
                necessaryLevel: 18,
            },
            {
                level: 4,
                cooldown: 60,
                mp: 48,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 23 segundos reinicializando a taxa de perigo.",
                necessaryLevel: 22,
            },
            {
                level: 5,
                cooldown: 60,
                mp: 57,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 24 segundos reinicializando a taxa de perigo e aumentando a velocidade de movimento em 3.",
                necessaryLevel: 26,
            },
            {
                level: 6,
                cooldown: 60,
                mp: 69,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 25 segundos reinicializando a taxa de perigo e aumentando a velocidade de movimento em 6.",
                necessaryLevel: 30,
            },
            {
                level: 7,
                cooldown: 60,
                mp: 83,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 26 segundos reinicializando a taxa de perigo e aumentando a velocidade de movimento em 9.",
                necessaryLevel: 34,
            },
            {
                level: 8,
                cooldown: 60,
                mp: 99,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 27 segundos reinicializando a taxa de perigo e aumentando a velocidade de movimento em 12.",
                necessaryLevel: 38,
            },
            {
                level: 9,
                cooldown: 60,
                mp: 117,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 28 segundos reinicializando a taxa de perigo e aumentando a velocidade de movimento em 15.",
                necessaryLevel: 42,
            },
            {
                level: 10,
                cooldown: 60,
                mp: 136,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 30 segundos reinicializando a taxa de perigo e aumentando a velocidade de movimento em 18.",
                necessaryLevel: 46,
            },
        ],
    },
    {
        logoId: 6,
        name: "Tiro Descontrolado",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 113,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 174 de dano físico.",
                necessaryLevel: 12,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 141,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 217 de dano físico.",
                necessaryLevel: 16,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 174,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 268 de dano físico.",
                necessaryLevel: 20,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 211,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 325 de dano físico.",
                necessaryLevel: 24,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 255,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 393 de dano físico.",
                necessaryLevel: 28,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 311,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 479 de dano físico.",
                necessaryLevel: 32,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 376,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 579 de dano físico.",
                necessaryLevel: 36,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 454,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 698 de dano físico.",
                necessaryLevel: 40,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 536,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 824 de dano físico.",
                necessaryLevel: 44,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 632,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 972 de dano físico.",
                necessaryLevel: 48,
            },
            {
                level: 11,
                cooldown: 20,
                mp: 734,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 1129 de dano físico.",
                necessaryLevel: 52,
            },
            {
                level: 12,
                cooldown: 20,
                mp: 850,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 1308 de dano físico.",
                necessaryLevel: 56,
            },
            {
                level: 13,
                cooldown: 20,
                mp: 976,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 1496 de dano físico.",
                necessaryLevel: 60,
            },
            {
                level: 14,
                cooldown: 20,
                mp: 1099,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 1690 de dano físico.",
                necessaryLevel: 64,
            },
            {
                level: 15,
                cooldown: 20,
                mp: 1236,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 1901 de dano físico.",
                necessaryLevel: 68,
            },
            {
                level: 16,
                cooldown: 20,
                mp: 1390,
                cast: 0,
                info:
                    "Dispara cegamente várias vezes no inimigo causando 2138 de dano físico.",
                necessaryLevel: 72,
            },
        ],
    },
    {
        logoId: 7,
        name: "Veneno da Lentidão",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 155,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 15 inflingindo 77 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 17,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 190,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 17 inflingindo 94 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 21,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 230,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 19 inflingindo 114 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 25,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 278,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 21 inflingindo 138 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 29,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 339,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 23 inflingindo 168 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 33,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 411,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 25 inflingindo 203 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 37,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 490,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 27 inflingindo 242 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 41,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 578,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 29 inflingindo 286 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 45,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 682,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 31 inflingindo 337 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 49,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 789,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 33 inflingindo 390 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 53,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 914,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 35 inflingindo 452 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 57,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 1043,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 37 inflingindo 516 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 61,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 1173,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 39 inflingindo 580 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 65,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 1318,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 41 inflingindo 653 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 69,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 1482,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 43 inflingindo 733 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 73,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 1653,
                cast: 0,
                info:
                    "Atira uma bala venenosa que diminui a velocidade de movimento em 45 inflingindo 818 de dano físico por segundo durante 8 segundos.",
                necessaryLevel: 77,
            },
        ],
    },
    {
        logoId: 8,
        name: "Réquiem",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 51,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 75 de dano real para cada ataque e diminui a precisão em 9 pontos por 10 segundos.",
                necessaryLevel: 19,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 62,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 91 de dano real para cada ataque e diminui a precisão em 11 pontos por 10 segundos.",
                necessaryLevel: 23,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 76,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 110 de dano real para cada ataque e diminui a precisão em 13 pontos por 10 segundos.",
                necessaryLevel: 27,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 92,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 132 de dano real para cada ataque e diminui a precisão em 15 pontos por 10 segundos.",
                necessaryLevel: 31,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 111,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 159 de dano real para cada ataque e diminui a precisão em 17 pontos por 10 segundos.",
                necessaryLevel: 35,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 134,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 192 de dano real para cada ataque e diminui a precisão em 19 pontos por 10 segundos.",
                necessaryLevel: 39,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 159,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 226 de dano real para cada ataque e diminui a precisão em 21 pontos por 10 segundos.",
                necessaryLevel: 43,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 188,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 266 de dano real para cada ataque e diminui a precisão em 23 pontos por 10 segundos.",
                necessaryLevel: 47,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 219,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 310 de dano real para cada ataque e diminui a precisão em 25 pontos por 10 segundos.",
                necessaryLevel: 51,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 253,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 358 de dano real para cada ataque e diminui a precisão em 27 pontos por 10 segundos.",
                necessaryLevel: 55,
            },
            {
                level: 11,
                cooldown: 20,
                mp: 290,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 414 de dano real para cada ataque e diminui a precisão em 29 pontos por 10 segundos.",
                necessaryLevel: 59,
            },
            {
                level: 12,
                cooldown: 20,
                mp: 330,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 465 de dano real para cada ataque e diminui a precisão em 31 pontos por 10 segundos.",
                necessaryLevel: 63,
            },
            {
                level: 13,
                cooldown: 20,
                mp: 370,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 522 de dano real para cada ataque e diminui a precisão em 33 pontos por 10 segundos.",
                necessaryLevel: 67,
            },
            {
                level: 14,
                cooldown: 20,
                mp: 416,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 586 de dano real para cada ataque e diminui a precisão em 35 pontos por 10 segundos.",
                necessaryLevel: 71,
            },
            {
                level: 15,
                cooldown: 20,
                mp: 467,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 657 de dano real para cada ataque e diminui a precisão em 37 pontos por 10 segundos.",
                necessaryLevel: 75,
            },
            {
                level: 16,
                cooldown: 20,
                mp: 518,
                cast: 0,
                info:
                    "Coloca o inimigo sob um pacto de morte inflingindo 730 de dano real para cada ataque e diminui a precisão em 40 pontos por 10 segundos.",
                necessaryLevel: 79,
            },
        ],
    },
    {
        logoId: 9,
        name: "Olhar Penetrante",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta o crítico em 1 ponto e o dano de crítico em 3%.",
                necessaryLevel: 21,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o crítico em 2 pontos e o dano de crítico em 6%.",
                necessaryLevel: 25,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o crítico em 3 pontos e o dano de crítico em 9%.",
                necessaryLevel: 29,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o crítico em 4 pontos e o dano de crítico em 12%.",
                necessaryLevel: 33,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o crítico em 5 pontos e o dano de crítico em 15%.",
                necessaryLevel: 37,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o crítico em 6 pontos e o dano de crítico em 18%.",
                necessaryLevel: 41,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o crítico em 7 pontos e o dano de crítico em 21%.",
                necessaryLevel: 45,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o crítico em 8 pontos e o dano de crítico em 24%.",
                necessaryLevel: 49,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o crítico em 9 pontos e o dano de crítico em 27%.",
                necessaryLevel: 53,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o crítico em 10 pontos e o dano de crítico em 30%.",
                necessaryLevel: 57,
            },
        ],
    },
    {
        logoId: 10,
        name: "Movimento Gracioso",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta a evasão em 3 pontos.",
                necessaryLevel: 23,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta a evasão em 4 pontos.",
                necessaryLevel: 27,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta a evasão em 5 pontos.",
                necessaryLevel: 31,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta a evasão em 6 pontos.",
                necessaryLevel: 35,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta a evasão em 7 pontos.",
                necessaryLevel: 39,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta a evasão em 8 pontos.",
                necessaryLevel: 43,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta a evasão em 9 pontos.",
                necessaryLevel: 47,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta a evasão em 10 pontos.",
                necessaryLevel: 51,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta a evasão em 11 pontos.",
                necessaryLevel: 55,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta a evasão em 12 pontos.",
                necessaryLevel: 59,
            },
        ],
    },
    {
        logoId: 11,
        name: "Rosa Negra",
        levelsInfo: [
            {
                level: 1,
                cooldown: 240,
                mp: 110,
                cast: 0,
                info: "Durante 2 minutos aumenta o crítico em 20 pontos.",
                necessaryLevel: 25,
            },
            {
                level: 2,
                cooldown: 240,
                mp: 132,
                cast: 0,
                info: "Durante 2 minutos aumenta o crítico em 23 pontos.",
                necessaryLevel: 29,
            },
            {
                level: 3,
                cooldown: 240,
                mp: 158,
                cast: 0,
                info: "Durante 2 minutos aumenta o crítico em 26 pontos.",
                necessaryLevel: 33,
            },
            {
                level: 4,
                cooldown: 240,
                mp: 190,
                cast: 0,
                info: "Durante 2 minutos aumenta o crítico em 29 pontos.",
                necessaryLevel: 37,
            },
            {
                level: 5,
                cooldown: 240,
                mp: 224,
                cast: 0,
                info: "Durante 2 minutos aumenta o crítico em 32 pontos.",
                necessaryLevel: 41,
            },
            {
                level: 6,
                cooldown: 240,
                mp: 262,
                cast: 0,
                info: "Durante 2 minutos aumenta o crítico em 35 pontos.",
                necessaryLevel: 45,
            },
            {
                level: 7,
                cooldown: 240,
                mp: 306,
                cast: 0,
                info: "Durante 2 minutos aumenta o crítico em 38 pontos.",
                necessaryLevel: 49,
            },
            {
                level: 8,
                cooldown: 240,
                mp: 350,
                cast: 0,
                info: "Durante 2 minutos aumenta o crítico em 41 pontos.",
                necessaryLevel: 53,
            },
            {
                level: 9,
                cooldown: 240,
                mp: 402,
                cast: 0,
                info: "Durante 2 minutos aumenta o crítico em 44 pontos.",
                necessaryLevel: 57,
            },
            {
                level: 10,
                cooldown: 240,
                mp: 453,
                cast: 0,
                info: "Durante 2 minutos aumenta o crítico em 50 pontos.",
                necessaryLevel: 61,
            },
        ],
    },
    {
        logoId: 12,
        name: "Veneno de Mana",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 138,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 133 de dano físico e remove 8% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 27,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 166,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 160 de dano físico e remove 8% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 31,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 202,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 194 de dano físico e remove 9% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 35,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 244,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 235 de dano físico e remove 9% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 39,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 288,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 277 de dano físico e remove 10% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 43,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 341,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 328 de dano físico e remove 10% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 47,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 397,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 382 de dano físico e remove 11% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 51,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 460,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 442 de dano físico e remove 11% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 55,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 527,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 506 de dano físico e remove 12% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 59,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 599,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 576 de dano físico e remove 12% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 63,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 674,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 648 de dano físico e remove 13% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 67,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 757,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 728 de dano físico e remove 13% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 71,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 849,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 816 de dano físico e remove 14% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 75,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 943,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 907 de dano físico e remove 14% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 79,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 1048,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 1008 de dano físico e remove 15% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 83,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 1165,
                cast: 0,
                info:
                    "Atira uma bala venenosa que inflige 1120 de dano físico e remove 15% da mana máxima do alvo convertendo em dano real extra.",
                necessaryLevel: 87,
            },
        ],
    },
    {
        logoId: 13,
        name: "Fumaça Sangrenta",
        levelsInfo: [
            {
                level: 1,
                cooldown: 40,
                mp: 280,
                cast: 0,
                info:
                    "Causa 538 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 32,
            },
            {
                level: 2,
                cooldown: 40,
                mp: 338,
                cast: 0,
                info:
                    "Causa 650 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 36,
            },
            {
                level: 3,
                cooldown: 40,
                mp: 408,
                cast: 0,
                info:
                    "Causa 784 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 40,
            },
            {
                level: 4,
                cooldown: 40,
                mp: 481,
                cast: 0,
                info:
                    "Causa 925 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 44,
            },
            {
                level: 5,
                cooldown: 40,
                mp: 567,
                cast: 0,
                info:
                    "Causa 1091 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 48,
            },
            {
                level: 6,
                cooldown: 40,
                mp: 659,
                cast: 0,
                info:
                    "Causa 1267 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 52,
            },
            {
                level: 7,
                cooldown: 40,
                mp: 764,
                cast: 0,
                info:
                    "Causa 1469 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 56,
            },
            {
                level: 8,
                cooldown: 40,
                mp: 877,
                cast: 0,
                info:
                    "Causa 1686 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 60,
            },
            {
                level: 9,
                cooldown: 40,
                mp: 987,
                cast: 0,
                info:
                    "Causa 1898 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 64,
            },
            {
                level: 10,
                cooldown: 40,
                mp: 1110,
                cast: 0,
                info:
                    "Causa 2134 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 68,
            },
            {
                level: 11,
                cooldown: 40,
                mp: 1248,
                cast: 0,
                info:
                    "Causa 2400 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 72,
            },
            {
                level: 12,
                cooldown: 40,
                mp: 1395,
                cast: 0,
                info:
                    "Causa 2682 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 76,
            },
            {
                level: 13,
                cooldown: 40,
                mp: 1549,
                cast: 0,
                info:
                    "Causa 2979 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 80,
            },
            {
                level: 14,
                cooldown: 40,
                mp: 1721,
                cast: 0,
                info:
                    "Causa 3309 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 84,
            },
            {
                level: 15,
                cooldown: 40,
                mp: 1912,
                cast: 0,
                info:
                    "Causa 3677 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 88,
            },
            {
                level: 16,
                cooldown: 40,
                mp: 2123,
                cast: 0,
                info:
                    "Causa 4083 de dano físico aos inimigos numa área de 5 metros.",
                necessaryLevel: 92,
            },
        ],
    },
    {
        logoId: 14,
        name: "Choque Súbito",
        levelsInfo: [
            {
                level: 1,
                cooldown: 90,
                mp: 86,
                cast: 0,
                info:
                    "Põe o inimigo em um estado de choque durante 10 segundos e adiciona 230 de dano real se for atacado enquanto estiver em choque.",
                necessaryLevel: 34,
            },
            {
                level: 2,
                cooldown: 90,
                mp: 104,
                cast: 0,
                info:
                    "Põe o inimigo em um estado de choque durante 12 segundos e adiciona 280 de dano real se for atacado enquanto estiver em choque.",
                necessaryLevel: 38,
            },
            {
                level: 3,
                cooldown: 90,
                mp: 124,
                cast: 0,
                info:
                    "Põe o inimigo em um estado de choque durante 14 segundos e adiciona 333 de dano real se for atacado enquanto estiver em choque.",
                necessaryLevel: 42,
            },
            {
                level: 4,
                cooldown: 90,
                mp: 146,
                cast: 0,
                info:
                    "Põe o inimigo em um estado de choque durante 16 segundos e adiciona 393 de dano real se for atacado enquanto estiver em choque.",
                necessaryLevel: 46,
            },
            {
                level: 5,
                cooldown: 90,
                mp: 171,
                cast: 0,
                info:
                    "Põe o inimigo em um estado de choque durante 18 segundos e adiciona 460 de dano real se for atacado enquanto estiver em choque.",
                necessaryLevel: 50,
            },
            {
                level: 6,
                cooldown: 90,
                mp: 198,
                cast: 0,
                info:
                    "Põe o inimigo em um estado de choque durante 20 segundos e adiciona 534 de dano real se for atacado enquanto estiver em choque.",
                necessaryLevel: 54,
            },
            {
                level: 7,
                cooldown: 90,
                mp: 230,
                cast: 0,
                info:
                    "Põe o inimigo em um estado de choque durante 22 segundos e adiciona 616 de dano real se for atacado enquanto estiver em choque.",
                necessaryLevel: 58,
            },
            {
                level: 8,
                cooldown: 90,
                mp: 260,
                cast: 0,
                info:
                    "Põe o inimigo em um estado de choque durante 24 segundos e adiciona 700 de dano real se for atacado enquanto estiver em choque.",
                necessaryLevel: 62,
            },
            {
                level: 9,
                cooldown: 90,
                mp: 293,
                cast: 0,
                info:
                    "Põe o inimigo em um estado de choque durante 26 segundos e adiciona 788 de dano real se for atacado enquanto estiver em choque.",
                necessaryLevel: 66,
            },
            {
                level: 10,
                cooldown: 90,
                mp: 328,
                cast: 0,
                info:
                    "Põe o inimigo em um estado de choque durante 30 segundos e adiciona 884 de dano real se for atacado enquanto estiver em choque.",
                necessaryLevel: 70,
            },
        ],
    },
    {
        logoId: 15,
        name: "Explosão Radiante",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 146,
                cast: 0,
                info:
                    "Atira um projétil luminoso que causa 244 de  dano físico e cegueira parcial durante 3 segundos em todos os inimigos em um raio de 3 metros.",
                necessaryLevel: 36,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 176,
                cast: 0,
                info:
                    "Atira um projétil luminoso que causa 294 de  dano físico e cegueira parcial durante 4 segundos em todos os inimigos em um raio de 3 metros.",
                necessaryLevel: 40,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 208,
                cast: 0,
                info:
                    "Atira um projétil luminoso que causa 347 de  dano físico e cegueira parcial durante 5 segundos em todos os inimigos em um raio de 3 metros.",
                necessaryLevel: 44,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 245,
                cast: 0,
                info:
                    "Atira um projétil luminoso que causa 409 de  dano físico e cegueira parcial durante 6 segundos em todos os inimigos em um raio de 3 metros.",
                necessaryLevel: 48,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 285,
                cast: 0,
                info:
                    "Atira um projétil luminoso que causa 475 de  dano físico e cegueira parcial durante 7 segundos em todos os inimigos em um raio de 3 metros.",
                necessaryLevel: 52,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 331,
                cast: 0,
                info:
                    "Atira um projétil luminoso que causa 551 de  dano físico e cegueira parcial durante 8 segundos em todos os inimigos em um raio de 3 metros.",
                necessaryLevel: 56,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 379,
                cast: 0,
                info:
                    "Atira um projétil luminoso que causa 631 de  dano físico e cegueira parcial durante 9 segundos em todos os inimigos em um raio de 3 metros.",
                necessaryLevel: 60,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 427,
                cast: 0,
                info:
                    "Atira um projétil luminoso que causa 712 de  dano físico e cegueira parcial durante 10 segundos em todos os inimigos em um raio de 3 metros.",
                necessaryLevel: 64,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 480,
                cast: 0,
                info:
                    "Atira um projétil luminoso que causa 800 de  dano físico e cegueira parcial durante 11 segundos em todos os inimigos em um raio de 3 metros.",
                necessaryLevel: 68,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 540,
                cast: 0,
                info:
                    "Atira um projétil luminoso que causa 900 de  dano físico e cegueira parcial durante 12 segundos em todos os inimigos em um raio de 3 metros.",
                necessaryLevel: 72,
            },
        ],
    },
    {
        logoId: 16,
        name: "Negar Cura",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 128,
                cast: 0,
                info:
                    "Envenena o alvo causando um debuff que aplica 100% de dano baseado na cura recebida em um toral de 3 vezes durante 10 segundos.",
                necessaryLevel: 38,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 152,
                cast: 0,
                info:
                    "Envenena o alvo causando um debuff que aplica 110% de dano baseado na cura recebida em um toral de 3 vezes durante 15 segundos.",
                necessaryLevel: 42,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 180,
                cast: 0,
                info:
                    "Envenena o alvo causando um debuff que aplica 120% de dano baseado na cura recebida em um toral de 3 vezes durante 20 segundos.",
                necessaryLevel: 46,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 211,
                cast: 0,
                info:
                    "Envenena o alvo causando um debuff que aplica 130% de dano baseado na cura recebida em um toral de 3 vezes durante 25 segundos.",
                necessaryLevel: 50,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 244,
                cast: 0,
                info:
                    "Envenena o alvo causando um debuff que aplica 140% de dano baseado na cura recebida em um toral de 3 vezes durante 30 segundos.",
                necessaryLevel: 54,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 283,
                cast: 0,
                info:
                    "Envenena o alvo causando um debuff que aplica 150% de dano baseado na cura recebida em um toral de 3 vezes durante 35 segundos.",
                necessaryLevel: 58,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 320,
                cast: 0,
                info:
                    "Envenena o alvo causando um debuff que aplica 160% de dano baseado na cura recebida em um toral de 3 vezes durante 40 segundos.",
                necessaryLevel: 62,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 360,
                cast: 0,
                info:
                    "Envenena o alvo causando um debuff que aplica 170% de dano baseado na cura recebida em um toral de 3 vezes durante 45 segundos.",
                necessaryLevel: 66,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 404,
                cast: 0,
                info:
                    "Envenena o alvo causando um debuff que aplica 180% de dano baseado na cura recebida em um toral de 3 vezes durante 50 segundos.",
                necessaryLevel: 70,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 454,
                cast: 0,
                info:
                    "Envenena o alvo causando um debuff que aplica 200% de dano baseado na cura recebida em um toral de 3 vezes durante 60 segundos.",
                necessaryLevel: 74,
            },
        ],
    },
    {
        logoId: 17,
        name: "Disparos Rápidos",
        levelsInfo: [
            {
                level: 1,
                cooldown: 300,
                mp: 216,
                cast: 0,
                info:
                    "Reinicializa o tempo de espera de todas as habilidades e reduz durante 30 segundos o tempo de espera de todas as habilidades em 25%.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 300,
                mp: 252,
                cast: 0,
                info:
                    "Reinicializa o tempo de espera de todas as habilidades e reduz durante 40 segundos o tempo de espera de todas as habilidades em 30%.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 300,
                mp: 295,
                cast: 0,
                info:
                    "Reinicializa o tempo de espera de todas as habilidades e reduz durante 50 segundos o tempo de espera de todas as habilidades em 35%.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 300,
                mp: 338,
                cast: 0,
                info:
                    "Reinicializa o tempo de espera de todas as habilidades e reduz durante 60 segundos o tempo de espera de todas as habilidades em 40%.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 300,
                mp: 388,
                cast: 0,
                info:
                    "Reinicializa o tempo de espera de todas as habilidades e reduz durante 70 segundos o tempo de espera de todas as habilidades em 45%.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 300,
                mp: 441,
                cast: 0,
                info:
                    "Reinicializa o tempo de espera de todas as habilidades e reduz durante 80 segundos o tempo de espera de todas as habilidades em 50%.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 300,
                mp: 491,
                cast: 0,
                info:
                    "Reinicializa o tempo de espera de todas as habilidades e reduz durante 90 segundos o tempo de espera de todas as habilidades em 55%.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 300,
                mp: 546,
                cast: 0,
                info:
                    "Reinicializa o tempo de espera de todas as habilidades e reduz durante 100 segundos o tempo de espera de todas as habilidades em 57%.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 300,
                mp: 608,
                cast: 0,
                info:
                    "Reinicializa o tempo de espera de todas as habilidades e reduz durante 110 segundos o tempo de espera de todas as habilidades em 59%.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 300,
                mp: 672,
                cast: 0,
                info:
                    "Reinicializa o tempo de espera de todas as habilidades e reduz durante 120 segundos o tempo de espera de todas as habilidades em 60%.",
                necessaryLevel: 76,
            },
        ],
    },
    {
        logoId: 18,
        name: "Estripador",
        levelsInfo: [
            {
                level: 1,
                cooldown: 40,
                mp: 319,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 613 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 4 segundos.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 40,
                mp: 376,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 723 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 4 segundos.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 40,
                mp: 444,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 853 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 4 segundos.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 40,
                mp: 515,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 990 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 4 segundos.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 40,
                mp: 597,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 1148 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 4 segundos.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 40,
                mp: 685,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 1313 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 4 segundos.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 40,
                mp: 771,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 1483 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 4 segundos.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 40,
                mp: 867,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 1668 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 4 segundos.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 40,
                mp: 975,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 1875 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 5 segundos.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 40,
                mp: 1089,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 2095 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 5 segundos.",
                necessaryLevel: 76,
            },
            {
                level: 11,
                cooldown: 40,
                mp: 1211,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 2328 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 5 segundos.",
                necessaryLevel: 80,
            },
            {
                level: 12,
                cooldown: 40,
                mp: 1344,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 2585 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 5 segundos.",
                necessaryLevel: 84,
            },
            {
                level: 13,
                cooldown: 40,
                mp: 1494,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 2873 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 5 segundos.",
                necessaryLevel: 88,
            },
            {
                level: 14,
                cooldown: 40,
                mp: 1659,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 3163 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 5 segundos.",
                necessaryLevel: 92,
            },
            {
                level: 15,
                cooldown: 40,
                mp: 1842,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 3480 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 5 segundos.",
                necessaryLevel: 96,
            },
            {
                level: 16,
                cooldown: 40,
                mp: 1993,
                cast: 0,
                info:
                    "Atira um projétil que enfraquece o alvo durante 10 segundos e causa 3833 de dano físico onde todos os ataques críticos subsequentes causam atordoamento com duração de 6 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 19,
        name: "Veneno Hidra",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 397,
                cast: 0,
                info:
                    "Atira um projétil paralisante que causa 764 de dano físico e paralisa o alvo por 3 segundos.",
                necessaryLevel: 51,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 460,
                cast: 0,
                info:
                    "Atira um projétil paralisante que causa 884 de dano físico e paralisa o alvo por 3 segundos.",
                necessaryLevel: 55,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 527,
                cast: 0,
                info:
                    "Atira um projétil paralisante que causa 1012 de dano físico e paralisa o alvo por 3 segundos.",
                necessaryLevel: 59,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 599,
                cast: 0,
                info:
                    "Atira um projétil paralisante que causa 1152 de dano físico e paralisa o alvo por 3 segundos.",
                necessaryLevel: 63,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 674,
                cast: 0,
                info:
                    "Atira um projétil paralisante que causa 1296 de dano físico e paralisa o alvo por 3 segundos.",
                necessaryLevel: 67,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 757,
                cast: 0,
                info:
                    "Atira um projétil paralisante que causa 1456 de dano físico e paralisa o alvo por 3 segundos.",
                necessaryLevel: 71,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 849,
                cast: 0,
                info:
                    "Atira um projétil paralisante que causa 1632 de dano físico e paralisa o alvo por 3 segundos.",
                necessaryLevel: 75,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 943,
                cast: 0,
                info:
                    "Atira um projétil paralisante que causa 1814 de dano físico e paralisa o alvo por 3 segundos.",
                necessaryLevel: 79,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 1048,
                cast: 0,
                info:
                    "Atira um projétil paralisante que causa 2016 de dano físico e paralisa o alvo por 3 segundos.",
                necessaryLevel: 83,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 1165,
                cast: 0,
                info:
                    "Atira um projétil paralisante que causa 2240 de dano físico e paralisa o alvo por 3 segundos.",
                necessaryLevel: 87,
            },
        ],
    },
    {
        logoId: 20,
        name: "Vento Cortante",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a possibilidade de resistir a lentidão em 5% e resistir a paralisia em 3%.",
                necessaryLevel: 55,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a possibilidade de resistir a lentidão em 10% e resistir a paralisia em 6%.",
                necessaryLevel: 59,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a possibilidade de resistir a lentidão em 15% e resistir a paralisia em 9%.",
                necessaryLevel: 63,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a possibilidade de resistir a lentidão em 20% e resistir a paralisia em 12%.",
                necessaryLevel: 67,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a possibilidade de resistir a lentidão em 25% e resistir a paralisia em 15%.",
                necessaryLevel: 71,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a possibilidade de resistir a lentidão em 30% e resistir a paralisia em 18%.",
                necessaryLevel: 75,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a possibilidade de resistir a lentidão em 35% e resistir a paralisia em 21%.",
                necessaryLevel: 79,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a possibilidade de resistir a lentidão em 40% e resistir a paralisia em 24%.",
                necessaryLevel: 83,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a possibilidade de resistir a lentidão em 45% e resistir a paralisia em 27%.",
                necessaryLevel: 87,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a possibilidade de resistir a lentidão em 50% e resistir a paralisia em 30%.",
                necessaryLevel: 91,
            },
        ],
    },
    {
        logoId: 21,
        name: "Rosa Sangrenta",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 859,
                cast: 0,
                info:
                    "Potencializa as pistolas com uma energia que causa dano em área equivalente a 20% dos ataques básicos absorvendo 20% do dano como vida, aumentando o duplo em 20 durante 20 segundos. É necessário ativar a habilidade Maximizar nível 1 ou superior.",
                necessaryLevel: 59,
            },
            {
                level: 2,
                cooldown: 180,
                mp: 957,
                cast: 0,
                info:
                    "Potencializa as pistolas com uma energia que causa dano em área equivalente a 25% dos ataques básicos absorvendo 25% do dano como vida, aumentando o duplo em 22 durante 22 segundos. É necessário ativar a habilidade Maximizar nível 2 ou superior.",
                necessaryLevel: 63,
            },
            {
                level: 3,
                cooldown: 180,
                mp: 1065,
                cast: 0,
                info:
                    "Potencializa as pistolas com uma energia que causa dano em área equivalente a 30% dos ataques básicos absorvendo 30% do dano como vida, aumentando o duplo em 24 durante 24 segundos. É necessário ativar a habilidade Maximizar nível 3 ou superior.",
                necessaryLevel: 67,
            },
            {
                level: 4,
                cooldown: 180,
                mp: 1184,
                cast: 0,
                info:
                    "Potencializa as pistolas com uma energia que causa dano em área equivalente a 35% dos ataques básicos absorvendo 35% do dano como vida, aumentando o duplo em 26 durante 26 segundos. É necessário ativar a habilidade Maximizar nível 4 ou superior.",
                necessaryLevel: 71,
            },
            {
                level: 5,
                cooldown: 180,
                mp: 1313,
                cast: 0,
                info:
                    "Potencializa as pistolas com uma energia que causa dano em área equivalente a 40% dos ataques básicos absorvendo 40% do dano como vida, aumentando o duplo em 28 durante 28 segundos. É necessário ativar a habilidade Maximizar nível 5 ou superior.",
                necessaryLevel: 75,
            },
            {
                level: 6,
                cooldown: 180,
                mp: 1443,
                cast: 0,
                info:
                    "Potencializa as pistolas com uma energia que causa dano em área equivalente a 45% dos ataques básicos absorvendo 45% do dano como vida, aumentando o duplo em 30 durante 30 segundos. É necessário ativar a habilidade Maximizar nível 6 ou superior.",
                necessaryLevel: 79,
            },
            {
                level: 7,
                cooldown: 180,
                mp: 1586,
                cast: 0,
                info:
                    "Potencializa as pistolas com uma energia que causa dano em área equivalente a 50% dos ataques básicos absorvendo 50% do dano como vida, aumentando o duplo em 32 durante 32 segundos. É necessário ativar a habilidade Maximizar nível 7 ou superior.",
                necessaryLevel: 83,
            },
            {
                level: 8,
                cooldown: 180,
                mp: 1742,
                cast: 0,
                info:
                    "Potencializa as pistolas com uma energia que causa dano em área equivalente a 55% dos ataques básicos absorvendo 55% do dano como vida, aumentando o duplo em 34 durante 34 segundos. É necessário ativar a habilidade Maximizar nível 8 ou superior.",
                necessaryLevel: 87,
            },
            {
                level: 9,
                cooldown: 180,
                mp: 1913,
                cast: 0,
                info:
                    "Potencializa as pistolas com uma energia que causa dano em área equivalente a 60% dos ataques básicos absorvendo 60% do dano como vida, aumentando o duplo em 36 durante 36 segundos. É necessário ativar a habilidade Maximizar nível 9 ou superior.",
                necessaryLevel: 91,
            },
            {
                level: 10,
                cooldown: 180,
                mp: 2101,
                cast: 0,
                info:
                    "Potencializa as pistolas com uma energia que causa dano em área equivalente a 70% dos ataques básicos absorvendo 70% do dano como vida, aumentando o duplo em 40 durante 40 segundos. É necessário ativar a habilidade Maximizar nível 10 ou superior.",
                necessaryLevel: 95,
            },
        ],
    },
    {
        logoId: 22,
        name: "Choque Hidra",
        levelsInfo: [
            {
                level: 1,
                cooldown: 40,
                mp: 565,
                cast: 0,
                info:
                    "Causa 1086 de dano físico e aplica um aumento de 50% desse dano caso o alvo esteja paralisado.",
                necessaryLevel: 61,
            },
            {
                level: 2,
                cooldown: 40,
                mp: 635,
                cast: 0,
                info:
                    "Causa 1222 de dano físico e aplica um aumento de 52% desse dano caso o alvo esteja paralisado.",
                necessaryLevel: 65,
            },
            {
                level: 3,
                cooldown: 40,
                mp: 714,
                cast: 0,
                info:
                    "Causa 1374 de dano físico e aplica um aumento de 54% desse dano caso o alvo esteja paralisado.",
                necessaryLevel: 69,
            },
            {
                level: 4,
                cooldown: 40,
                mp: 803,
                cast: 0,
                info:
                    "Causa 1544 de dano físico e aplica um aumento de 56% desse dano caso o alvo esteja paralisado.",
                necessaryLevel: 73,
            },
            {
                level: 5,
                cooldown: 40,
                mp: 895,
                cast: 0,
                info:
                    "Causa 1722 de dano físico e aplica um aumento de 58% desse dano caso o alvo esteja paralisado.",
                necessaryLevel: 77,
            },
            {
                level: 6,
                cooldown: 40,
                mp: 994,
                cast: 0,
                info:
                    "Causa 1912 de dano físico e aplica um aumento de 60% desse dano caso o alvo esteja paralisado.",
                necessaryLevel: 81,
            },
            {
                level: 7,
                cooldown: 40,
                mp: 1103,
                cast: 0,
                info:
                    "Causa 2122 de dano físico e aplica um aumento de 62% desse dano caso o alvo esteja paralisado.",
                necessaryLevel: 85,
            },
            {
                level: 8,
                cooldown: 40,
                mp: 1226,
                cast: 0,
                info:
                    "Causa 2358 de dano físico e aplica um aumento de 64% desse dano caso o alvo esteja paralisado.",
                necessaryLevel: 89,
            },
            {
                level: 9,
                cooldown: 40,
                mp: 1361,
                cast: 0,
                info:
                    "Causa 2618 de dano físico e aplica um aumento de 66% desse dano caso o alvo esteja paralisado.",
                necessaryLevel: 93,
            },
            {
                level: 10,
                cooldown: 40,
                mp: 1513,
                cast: 0,
                info:
                    "Causa 2910 de dano físico e aplica um aumento de 68% desse dano caso o alvo esteja paralisado.",
                necessaryLevel: 97,
            },
            {
                level: 11,
                cooldown: 40,
                mp: 1594,
                cast: 0,
                info:
                    "Causa 3066 de dano físico e aplica um aumento de 70% desse dano caso o alvo esteja paralisado.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 23,
        name: "Falsa Pontaria",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz a taxa de perigo sobre todas as ações e o custo de mana das habilidades de alvo único em 10%. Reduz o dano recebido de alvos marcados com a habilidade Ponto Cego em 75%.",
                necessaryLevel: 65,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz a taxa de perigo sobre todas as ações e o custo de mana das habilidades de alvo único em 12%. Reduz o dano recebido de alvos marcados com a habilidade Ponto Cego em 75%.",
                necessaryLevel: 69,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz a taxa de perigo sobre todas as ações e o custo de mana das habilidades de alvo único em 14%. Reduz o dano recebido de alvos marcados com a habilidade Ponto Cego em 75%.",
                necessaryLevel: 73,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz a taxa de perigo sobre todas as ações e o custo de mana das habilidades de alvo único em 16%. Reduz o dano recebido de alvos marcados com a habilidade Ponto Cego em 75%.",
                necessaryLevel: 77,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz a taxa de perigo sobre todas as ações e o custo de mana das habilidades de alvo único em 18%. Reduz o dano recebido de alvos marcados com a habilidade Ponto Cego em 75%.",
                necessaryLevel: 81,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz a taxa de perigo sobre todas as ações e o custo de mana das habilidades de alvo único em 20%. Reduz o dano recebido de alvos marcados com a habilidade Ponto Cego em 75%.",
                necessaryLevel: 85,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz a taxa de perigo sobre todas as ações e o custo de mana das habilidades de alvo único em 22%. Reduz o dano recebido de alvos marcados com a habilidade Ponto Cego em 75%.",
                necessaryLevel: 89,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz a taxa de perigo sobre todas as ações e o custo de mana das habilidades de alvo único em 24%. Reduz o dano recebido de alvos marcados com a habilidade Ponto Cego em 75%.",
                necessaryLevel: 93,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz a taxa de perigo sobre todas as ações e o custo de mana das habilidades de alvo único em 26%. Reduz o dano recebido de alvos marcados com a habilidade Ponto Cego em 75%.",
                necessaryLevel: 97,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz a taxa de perigo sobre todas as ações e o custo de mana das habilidades de alvo único em 30%. Reduz o dano recebido de alvos marcados com a habilidade Ponto Cego em 75%.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 24,
        name: "Disparo Demolidor",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 1286,
                cast: 0,
                info:
                    "Sobrecarrega as pistolas até o limite causando 2473 de dano físico no alvo e em uma área de 4 metros.",
                necessaryLevel: 69,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 1445,
                cast: 0,
                info:
                    "Sobrecarrega as pistolas até o limite causando 2779 de dano físico no alvo e em uma área de 4 metros.",
                necessaryLevel: 73,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 1612,
                cast: 0,
                info:
                    "Sobrecarrega as pistolas até o limite causando 3100 de dano físico no alvo e em uma área de 4 metros.",
                necessaryLevel: 77,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 1790,
                cast: 0,
                info:
                    "Sobrecarrega as pistolas até o limite causando 3442 de dano físico no alvo e em uma área de 4 metros.",
                necessaryLevel: 81,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 1986,
                cast: 0,
                info:
                    "Sobrecarrega as pistolas até o limite causando 3820 de dano físico no alvo e em uma área de 4 metros.",
                necessaryLevel: 85,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 2207,
                cast: 0,
                info:
                    "Sobrecarrega as pistolas até o limite causando 4244 de dano físico no alvo e em uma área de 4 metros.",
                necessaryLevel: 89,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 2450,
                cast: 0,
                info:
                    "Sobrecarrega as pistolas até o limite causando 4712 de dano físico no alvo e em uma área de 4 metros.",
                necessaryLevel: 93,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 2724,
                cast: 0,
                info:
                    "Sobrecarrega as pistolas até o limite causando 5238 de dano físico no alvo e em uma área de 4 metros.",
                necessaryLevel: 97,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 2870,
                cast: 0,
                info:
                    "Sobrecarrega as pistolas até o limite causando 5519 de dano físico no alvo e em uma área de 4 metros.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 25,
        name: "Dor do Predador",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 828,
                cast: 0,
                info:
                    "Causa 1274 de dano físico gravando a marca do assassino no alvo durante 10 segundos onde cada ataque recupera 202 de vida.",
                necessaryLevel: 71,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 928,
                cast: 0,
                info:
                    "Causa 1428 de dano físico gravando a marca do assassino no alvo durante 10 segundos onde cada ataque recupera 225 de vida.",
                necessaryLevel: 75,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 1032,
                cast: 0,
                info:
                    "Causa 1587 de dano físico gravando a marca do assassino no alvo durante 10 segundos onde cada ataque recupera 247 de vida.",
                necessaryLevel: 79,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 1147,
                cast: 0,
                info:
                    "Causa 1764 de dano físico gravando a marca do assassino no alvo durante 10 segundos onde cada ataque recupera 271 de vida.",
                necessaryLevel: 83,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 1274,
                cast: 0,
                info:
                    "Causa 1960 de dano físico gravando a marca do assassino no alvo durante 10 segundos onde cada ataque recupera 298 de vida.",
                necessaryLevel: 87,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 1414,
                cast: 0,
                info:
                    "Causa 2175 de dano físico gravando a marca do assassino no alvo durante 10 segundos onde cada ataque recupera 328 de vida.",
                necessaryLevel: 91,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 1570,
                cast: 0,
                info:
                    "Causa 2415 de dano físico gravando a marca do assassino no alvo durante 10 segundos onde cada ataque recupera 360 de vida.",
                necessaryLevel: 95,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 1744,
                cast: 0,
                info:
                    "Causa 2683 de dano físico gravando a marca do assassino no alvo durante 10 segundos onde cada ataque recupera 396 de vida.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 26,
        name: "Morte Decidida",
        levelsInfo: [
            {
                level: 1,
                cooldown: 40,
                mp: 1193,
                cast: 0,
                info:
                    "Causa 1836 de ataque físico e um dano adicional máximo de 2814 proporcional à diminuição de vida do alvo.",
                necessaryLevel: 75,
            },
            {
                level: 2,
                cooldown: 40,
                mp: 1327,
                cast: 0,
                info:
                    "Causa 2041 de ataque físico e um dano adicional máximo de 3092 proporcional à diminuição de vida do alvo.",
                necessaryLevel: 79,
            },
            {
                level: 3,
                cooldown: 40,
                mp: 1474,
                cast: 0,
                info:
                    "Causa 2268 de ataque físico e um dano adicional máximo de 3398 proporcional à diminuição de vida do alvo.",
                necessaryLevel: 83,
            },
            {
                level: 4,
                cooldown: 40,
                mp: 1638,
                cast: 0,
                info:
                    "Causa 2520 de ataque físico e um dano adicional máximo de 3734 proporcional à diminuição de vida do alvo.",
                necessaryLevel: 87,
            },
            {
                level: 5,
                cooldown: 40,
                mp: 1818,
                cast: 0,
                info:
                    "Causa 2797 de ataque físico e um dano adicional máximo de 4100 proporcional à diminuição de vida do alvo.",
                necessaryLevel: 91,
            },
            {
                level: 6,
                cooldown: 40,
                mp: 2018,
                cast: 0,
                info:
                    "Causa 3105 de ataque físico e um dano adicional máximo de 4502 proporcional à diminuição de vida do alvo.",
                necessaryLevel: 95,
            },
            {
                level: 7,
                cooldown: 40,
                mp: 2242,
                cast: 0,
                info:
                    "Causa 3449 de ataque físico e um dano adicional máximo de 4944 proporcional à diminuição de vida do alvo.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 27,
        name: "Reação em Cadeia",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 1474,
                cast: 0,
                info:
                    "Causa 2268 de ataque físico e 330 de dano adicional para cada debuff do alvo. Entra em modo de movimento em cadeia bonificando com 80 esquiva e 30 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 79,
            },
            {
                level: 2,
                cooldown: 60,
                mp: 1638,
                cast: 0,
                info:
                    "Causa 2520 de ataque físico e 366 de dano adicional para cada debuff do alvo. Entra em modo de movimento em cadeia bonificando com 80 esquiva e 30 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 83,
            },
            {
                level: 3,
                cooldown: 60,
                mp: 1820,
                cast: 0,
                info:
                    "Causa 2800 de ataque físico e 407 de dano adicional para cada debuff do alvo. Entra em modo de movimento em cadeia bonificando com 80 esquiva e 30 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 87,
            },
            {
                level: 4,
                cooldown: 60,
                mp: 2020,
                cast: 0,
                info:
                    "Causa 3108 de ataque físico e 454 de dano adicional para cada debuff do alvo. Entra em modo de movimento em cadeia bonificando com 80 esquiva e 30 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 91,
            },
            {
                level: 5,
                cooldown: 60,
                mp: 2243,
                cast: 0,
                info:
                    "Causa 3450 de ataque físico e 504 de dano adicional para cada debuff do alvo. Entra em modo de movimento em cadeia bonificando com 80 esquiva e 30 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 95,
            },
            {
                level: 6,
                cooldown: 60,
                mp: 2491,
                cast: 0,
                info:
                    "Causa 3833 de ataque físico e 560 de dano adicional para cada debuff do alvo. Entra em modo de movimento em cadeia bonificando com 80 esquiva e 30 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 28,
        name: "Ponto Cego",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 1709,
                cast: 0,
                info:
                    "Atira um projétil que explode em área causando 2629 de dano físico em um raio de 4 metros. Durante 10 segundos o alvo fica marcado com uma maldição que reduz o seu dano causado em 75%. Necessário ter um ponto na habilidade Falsa Pontaria.",
                necessaryLevel: 81,
            },
            {
                level: 2,
                cooldown: 60,
                mp: 1897,
                cast: 0,
                info:
                    "Atira um projétil que explode em área causando 2918 de dano físico em um raio de 4 metros. Durante 12 segundos o alvo fica marcado com uma maldição que reduz o seu dano causado em 75%. Necessário ter um ponto na habilidade Falsa Pontaria.",
                necessaryLevel: 85,
            },
            {
                level: 3,
                cooldown: 60,
                mp: 2017,
                cast: 0,
                info:
                    "Atira um projétil que explode em área causando 3242 de dano físico em um raio de 4 metros. Durante 14 segundos o alvo fica marcado com uma maldição que reduz o seu dano causado em 75%. Necessário ter um ponto na habilidade Falsa Pontaria.",
                necessaryLevel: 89,
            },
            {
                level: 4,
                cooldown: 60,
                mp: 2340,
                cast: 0,
                info:
                    "Atira um projétil que explode em área causando 3600 de dano físico em um raio de 4 metros. Durante 16 segundos o alvo fica marcado com uma maldição que reduz o seu dano causado em 75%. Necessário ter um ponto na habilidade Falsa Pontaria.",
                necessaryLevel: 93,
            },
            {
                level: 5,
                cooldown: 60,
                mp: 2601,
                cast: 0,
                info:
                    "Atira um projétil que explode em área causando 4001 de dano físico em um raio de 4 metros. Durante 18 segundos o alvo fica marcado com uma maldição que reduz o seu dano causado em 75%. Necessário ter um ponto na habilidade Falsa Pontaria.",
                necessaryLevel: 97,
            },
            {
                level: 6,
                cooldown: 60,
                mp: 2740,
                info:
                    "Atira um projétil que explode em área causando 4216 de dano físico em um raio de 4 metros. Durante 20 segundos o alvo fica marcado com uma maldição que reduz o seu dano causado em 75%. Necessário ter um ponto na habilidade Falsa Pontaria.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 29,
        name: "Penetrar Armadura",
        levelsInfo: [
            {
                level: 1,
                cooldown: 90,
                mp: 2077,
                cast: 0,
                info:
                    "Maximiza a capacidade das duas pistolas,aumentando o dano físico em 40% por 8 segundos, porém o desgaste das armas também em 20%.",
                necessaryLevel: 85,
            },
            {
                level: 2,
                cooldown: 90,
                mp: 2282,
                cast: 0,
                info:
                    "Maximiza a capacidade das duas pistolas,aumentando o dano físico em 45% por 10 segundos, porém o desgaste das armas também em 25%.",
                necessaryLevel: 89,
            },
            {
                level: 3,
                cooldown: 90,
                mp: 2506,
                cast: 0,
                info:
                    "Maximiza a capacidade das duas pistolas,aumentando o dano físico em 50% por 12 segundos, porém o desgaste das armas também em 30%.",
                necessaryLevel: 93,
            },
            {
                level: 4,
                cooldown: 90,
                mp: 27252,
                cast: 0,
                info:
                    "Maximiza a capacidade das duas pistolas,aumentando o dano físico em 55% por 14 segundos, porém o desgaste das armas também em 35%.",
                necessaryLevel: 97,
            },
            {
                level: 5,
                cooldown: 90,
                mp: 2884,
                info:
                    "Maximiza a capacidade das duas pistolas,aumentando o dano físico em 60% por 16 segundos, porém o desgaste das armas também em 40%.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 30,
        name: "Festival de Balas",
        levelsInfo: [
            {
                level: 1,
                cooldown: 110,
                mp: 2011,
                cast: 0,
                info:
                    "Dispara uma chuva de tiros causando 3867 de dano físico em inimigos ao redor de si atribuindo medo por 3 segundos. Essa habilidade oculta o personagem por 3 segundos.",
                necessaryLevel: 89,
            },
            {
                level: 2,
                cooldown: 110,
                mp: 2233,
                cast: 0,
                info:
                    "Dispara uma chuva de tiros causando 4294 de dano físico em inimigos ao redor de si atribuindo medo por 3 segundos. Essa habilidade oculta o personagem por 3 segundos.",
                necessaryLevel: 93,
            },
            {
                level: 3,
                cooldown: 110,
                mp: 2481,
                cast: 0,
                info:
                    "Dispara uma chuva de tiros causando 4772 de dano físico em inimigos ao redor de si atribuindo medo por 3 segundos. Essa habilidade oculta o personagem por 3 segundos.",
                necessaryLevel: 97,
            },
            {
                level: 4,
                cooldown: 110,
                mp: 2615,
                cast: 0,
                info:
                    "Dispara uma chuva de tiros causando 5028 de dano físico em inimigos ao redor de si atribuindo medo por 3 segundos. Essa habilidade oculta o personagem por 3 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 31,
        name: "Bomba Maldita",
        levelsInfo: [
            {
                level: 1,
                cooldown: 90,
                mp: 2685,
                cast: 0,
                info:
                    "Inflige 2760 de dano físico adicionando 447 de dano físico extra por cada efeito benéfico no alvo e implanta uma bomba que silencia o alvo por 5 segundos e explode causando 2070 de dano ao fim.",
                necessaryLevel: 95,
            },
            {
                level: 2,
                cooldown: 90,
                mp: 2981,
                cast: 0,
                info:
                    "Inflige 3066 de dano físico adicionando 496 de dano físico extra por cada efeito benéfico no alvo e implanta uma bomba que silencia o alvo por 5 segundos e explode causando 2300 de dano ao fim.",
                necessaryLevel: 99,
            },
        ],
    },
]
